const overrides = {
  root: {
    padding: '16px 24px',
  },
};

export default overrides;
